module.exports = __webpack_public_path__ + "static/Fabrik-Bold-5aac44b250e36ea619b52950b90ccf84.woff";